<script>
  import appConfig from '@src/app.config'
  import youtube from "@components/youtube/youtube-video.vue"
  import { contentComputed } from '@state/helpers'
  import SiteFeatures from '@components/features/features.vue'

export default {
  page: {
    title: 'Inicio',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: {youtube, SiteFeatures},

  computed: {
    ...contentComputed
  },
}
</script>

<template>
  <div>
    <p>{{ info.home.intro }}</p>

    <youtube :video="info.home.video" />

    <div class="text-center mt-5">
      <h2>{{ info.home.title }}</h2>
      <h4>{{ info.home.subtitle }}</h4>
    </div>

    <SiteFeatures :list="features" />
  </div>
</template>

<style lang="scss" scoped>
</style>
